<template>
  <b-container fluid id="app">
    <NavBar />
    <router-view />
    <Footer />
  </b-container>
</template>

<script>

import NavBar from '@/components/NavBar.vue';
import Footer from "./components/Footer";

export default {
  components: {Footer, NavBar}
};
</script>

<style>
  #app {
    box-sizing: border-box;
    width: 1000px;
    padding: 0 20px 20px;
    margin: 0 auto;
  }
</style>